<template>
  <div>
    <google-map
      ref="gm"
      :sharer="sharerId"
      :show-lengend="showLegend"
      map-style="elevation"
      :show-sites="true"
      :legend="legend" />
  </div>
</template>


<script>

import GoogleMapMixins from '@/mixins/GoogleMapMixins'
import NumberMixins from '@/mixins/NumberMixins'

import GoogleMap from '@/components/maps/GoogleMap'

export default {

  mixins: [GoogleMapMixins, NumberMixins],

  components: {
    GoogleMap
  },



  props: {

    sharer: {
      type: Number,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    showSites: {
      type: Boolean,
      default: true
    }

  },



  watch: {
    sharer: function (val) {
      this.sharerId = val === 0 ? null : Number(val)
      this.$refs.gm.sharerChange(this.sharerId)
    }

  },



  methods: {

    sharerStatus (m) {
      return m.content.siteName +
      ' | Sharers: ' + (this.hasSharerCount(m.content.sharers) ? Number(m.content.sharers) : 'unknown') + ' | ' +
      (m.content.structureType
        ? (m.content.structureType + (Number(m.content.structureHeight) > 0 ? ' (' + m.content.structureHeight + 'm)' : '') + ' | ')
        : '')
    },

    // 0 red | 1 green | 2 orange | 3 blue | 4 pink | 5+ yellow | unknown grey.
    // The legend below derives its icons from this method, so they cannot drift.
    mapSharerIcon (sharers) {

      if (!this.hasSharerCount(sharers)) {
        return this.greyIcon()
      }

      var n = Number(sharers)

      if (n === 0) {
        return this.redIcon()
      }

      if (n === 1) {
        return this.greenIcon()
      }

      if (n === 2) {
        return this.orangeIcon()
      }

      if (n === 3) {
        return this.blueIcon()
      }

      if (n === 4) {
        return this.pinkIcon()
      }

      return this.yellowIcon()
    }


  },



  data () {

    return {
      sharerId: this.sharer,
      legend: {
        title: 'Sharers',
        sharerId: this.sharer,
        statusFormatter: this.sharerStatus,
        mapIcon: this.mapSharerIcon,
        prop: 'sharers',
        legend: [
          { icon: this.mapSharerIcon(0), colour: this.mapIconColour(this.mapSharerIcon(0)), label: '0', alt: 'Red' },
          { icon: this.mapSharerIcon(1), colour: this.mapIconColour(this.mapSharerIcon(1)), label: '1', alt: 'Green' },
          { icon: this.mapSharerIcon(2), colour: this.mapIconColour(this.mapSharerIcon(2)), label: '2', alt: 'Orange' },
          { icon: this.mapSharerIcon(3), colour: this.mapIconColour(this.mapSharerIcon(3)), label: '3', alt: 'Blue' },
          { icon: this.mapSharerIcon(4), colour: this.mapIconColour(this.mapSharerIcon(4)), label: '4', alt: 'Pink' },
          { icon: this.mapSharerIcon(5), colour: this.mapIconColour(this.mapSharerIcon(5)), label: '5+', alt: 'Yellow' },
          { icon: this.mapSharerIcon(null), colour: this.mapIconColour(this.mapSharerIcon(null)), label: 'Unknown', alt: 'Grey' }
        ]
      }
    }

  }

}

</script>
